import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import CoordinateList from '../geom/CoordinateList';
import Coordinate from '../geom/Coordinate';
import LineSegment from '../geom/LineSegment';
var DouglasPeuckerLineSimplifier = /*#__PURE__*/function () {
  function DouglasPeuckerLineSimplifier() {
    _classCallCheck(this, DouglasPeuckerLineSimplifier);
    DouglasPeuckerLineSimplifier.constructor_.apply(this, arguments);
  }
  _createClass(DouglasPeuckerLineSimplifier, [{
    key: "simplifySection",
    value: function simplifySection(i, j) {
      if (i + 1 === j) return null;
      this._seg.p0 = this._pts[i];
      this._seg.p1 = this._pts[j];
      var maxDistance = -1.0;
      var maxIndex = i;
      for (var k = i + 1; k < j; k++) {
        var distance = this._seg.distance(this._pts[k]);
        if (distance > maxDistance) {
          maxDistance = distance;
          maxIndex = k;
        }
      }
      if (maxDistance <= this._distanceTolerance) {
        for (var _k = i + 1; _k < j; _k++) this._usePt[_k] = false;
      } else {
        this.simplifySection(i, maxIndex);
        this.simplifySection(maxIndex, j);
      }
    }
  }, {
    key: "setDistanceTolerance",
    value: function setDistanceTolerance(distanceTolerance) {
      this._distanceTolerance = distanceTolerance;
    }
  }, {
    key: "simplify",
    value: function simplify() {
      this._usePt = new Array(this._pts.length).fill(null);
      for (var i = 0; i < this._pts.length; i++) this._usePt[i] = true;
      this.simplifySection(0, this._pts.length - 1);
      var coordList = new CoordinateList();
      for (var _i = 0; _i < this._pts.length; _i++) if (this._usePt[_i]) coordList.add(new Coordinate(this._pts[_i]));
      return coordList.toCoordinateArray();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._pts = null;
      this._usePt = null;
      this._distanceTolerance = null;
      this._seg = new LineSegment();
      var pts = arguments[0];
      this._pts = pts;
    }
  }, {
    key: "simplify",
    value: function simplify(pts, distanceTolerance) {
      var simp = new DouglasPeuckerLineSimplifier(pts);
      simp.setDistanceTolerance(distanceTolerance);
      return simp.simplify();
    }
  }]);
  return DouglasPeuckerLineSimplifier;
}();
export { DouglasPeuckerLineSimplifier as default };